import React from 'react'
import { Button, ModalFooter, ButtonProps } from 'reactstrap'
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome'

interface Action {
  text: string
  wrapperProps?: React.HTMLAttributes<HTMLDivElement>
  icon: FontAwesomeIconProps['icon']
  iconProps?: Omit<FontAwesomeIconProps, 'icon'>
  color: ButtonProps['color']
  disabled?: boolean
  onAction?: () => Promise<void> | void
  iconPosition?: 'left' | 'right'
  position?: 'left' | 'right'
}

export interface FooterProps {
  onCancel?: () => void
  onAction?: () => Promise<void> | void
  cancel?: {
    text?: string
    disabled?: boolean
  }
  action?: Action | Action[]
  toggle: () => void
}

const Footer: React.FC<FooterProps> = (props) => {
  const {
    onCancel,
    onAction = () => {},
    toggle,
    action = []
  } = props
  const actions = Array.isArray(action) ? action : [action]
  const rightActions = actions.filter((a) => a.position === 'right' || a.position === undefined)
  const leftActions = actions.filter((a) => a.position === 'left')
  const cancel = Object.assign({ text: 'Cancel' }, props.cancel)

  const onCancelWrapper = (): void => {
    if (typeof onCancel === 'function') {
      onCancel()
    }
    toggle()
  }

  const handleAction = (actionFn?: Action['onAction']): void => {
    if (typeof actionFn === 'function') {
      void actionFn()
    } else {
      void onAction()
    }
  }

  return (
    <ModalFooter>
      <span className='me-auto'>
        {leftActions.map((action) => {
          const {
            disabled,
            color,
            onAction,
            icon,
            text,
            iconProps,
            wrapperProps = {},
            iconPosition = 'left'
          } = action
          return (
            <div key={text} className='d-inline-block' {...wrapperProps}>
              <Button
                disabled={disabled === true}
                color={color}
                onClick={() => handleAction(onAction)}
              >
                {iconPosition === 'left'
                  ? (
                    <><FontAwesomeIcon icon={icon} {...iconProps} />{' '}</>
                    )
                  : null}
                {text}
                {iconPosition === 'right'
                  ? (
                    <>{' '}<FontAwesomeIcon icon={icon} {...iconProps} /></>
                    )
                  : null}
              </Button>
            </div>
          )
        })}
      </span>
      <Button disabled={cancel.disabled === true} color='secondary' onClick={onCancelWrapper}>
        {cancel.text}
      </Button>
      {rightActions.map((action) => {
        const {
          disabled,
          color,
          onAction,
          icon,
          text,
          iconProps,
          wrapperProps = {},
          iconPosition = 'left'
        } = action
        return (
          <div key={text} className='d-inline-block' {...wrapperProps}>
            <Button
              disabled={disabled === true}
              color={color}
              onClick={() => handleAction(onAction)}
              key={text}
            >
              {iconPosition === 'left'
                ? (
                  <><FontAwesomeIcon icon={icon} {...iconProps} />{' '}</>
                  )
                : null}
              {text}
              {iconPosition === 'right'
                ? (
                  <>{' '}<FontAwesomeIcon icon={icon} {...iconProps} /></>
                  )
                : null}
            </Button>
          </div>
        )
      })}
    </ModalFooter>
  )
}

export default Footer
